import { useState, FC, ChangeEvent } from 'react';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import MainContainer from '../../ui_components/MainContainer';
import { LoadingState } from '../../stats_components/LoadingState';
import SearchFunctionGetListFromCharAndArray from '../../../utilities/SearchFunctionGetListFromCharAndArray';
import { useLoaderData, useNavigate } from 'react-router-dom';
import type { Arena } from '../../../types';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    /* background-color: ${colors.bgColorBlack2}; */
    /* border-radius: 10px;  */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
`;

const SpaceTitle = styled.div`
    width: 100%;
    /* height: 5%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colors.bgColorBlack2};

    & .title {
        font-size: 25px;
        letter-spacing: 2px;
        font-weight: 800;
        text-transform: uppercase;
        margin: 0;
        padding: 0;
        color: white;
    }
`;

const SpaceFilters = styled.div`
    width: 100%;
    /* height: 5%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    & .search-input {
        width: 50%;
        height: 100%;
        border: 1px solid white;
        border-radius: 10px;
        padding: 0 10px;
        margin: 10px 0;
    }

`;

const SpaceListArenas = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px;
    gap: 15px;
    overflow-y: auto;
    flex-wrap: wrap;
`;

const ContainerCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 45%;
    height: 40px;
    /* background-color: ${colors.bgColorBlack2}; */
    /* background: ${colors.gradientCardStatsWrestler}; */
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    border: 1px solid white;
    border-radius: 5px;
    color: white;
    overflow: hidden;
    /* padding: 2px 0; */

    &:hover {
        cursor: pointer;
        background-color: ${colors.bgColorBlack2};
        box-shadow: 0 0 10px rgba(0,0,0,0.8);
    }
`;

const AvatarSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80%;
    margin-bottom: 1px;

    & img.avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

const NameSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & h6.name {
        font-size: 6px;
        font-weight: 800;
        color: white;
        margin: 0;
        padding: 0;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
    }
`;

interface ArenaLoaderData {
    data: Arena[];
}

const ListArenasMobile: FC = () => {
    const [responseData, setResponseData] = useState<ArenaLoaderData>(useLoaderData() as ArenaLoaderData);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [listArenasDefault, setListArenasDefault] = useState<Arena[]>(responseData.data);
    const [listArenas, setListArenas] = useState<Arena[]>(listArenasDefault);
    const navigate = useNavigate();


    function handleSearchInput(e: ChangeEvent<HTMLInputElement>): void {
        const searchText = e.target.value;
        if(searchText.length > 0) {
            const filteredArenas = SearchFunctionGetListFromCharAndArray(searchText, listArenasDefault);
            setListArenas(filteredArenas);
        } else {
            setListArenas(listArenasDefault);
        }
    }

    // Funzione per l onclick che rimanda al arena specifico (Arena.js)
    function navigateGoToArena(id: number): void {
        let url = '/arenas/' + id;
        navigate(url);
    }

     // se è in loading, mostro il loading state
     if(isLoading) {
        return <LoadingState />;
    }


    return (
        <MainContainer isMobile={true} className='main-container-arenas-mobile'>
            <Wrapper className='wrapper-arenas-mobile'>

                <SpaceTitle className='space-title'>
                    <h1 className='title'>Arene</h1>
                </SpaceTitle>

                <SpaceFilters className='space-filters'>
                    <input type='text' placeholder='Cerca' className='search-input' onChange={handleSearchInput} />
                </SpaceFilters>

                <SpaceListArenas className='space-list-arenas'>
                    {listArenas.map((arena) => (
                        <ContainerCard
                         className='container-card'
                         key={arena.id}
                         onClick={() => navigateGoToArena(arena.id)}
                        >
                            <AvatarSpace className='avatar-space'>
                                <img src={process.env.REACT_APP_STORAGE_URL + arena.img_path} alt={arena.name} className='avatar' />
                            </AvatarSpace>
                            <NameSpace className='name-space'>
                                <h6 className='name'>{arena.name}</h6>
                            </NameSpace>
                        </ContainerCard>
                    ))}
                </SpaceListArenas>
            </Wrapper>
        </MainContainer>
    );
};

export default ListArenasMobile;
